export const NEW_TEMPLATE_FOLDER = 'NEW_TEMPLATE_FOLDER';
export const NEW_TEMPLATE_NAME = 'NEW_TEMPLATE_NAME';
export const NEW_TEMPLATE_API_NAME = 'NEW_TEMPLATE_API_NAME';
export const NEW_TEMPLATE_DESCRIPTION = 'NEW_TEMPLATE_DESCRIPTION';
export const NEW_TEMPLATE_CONTENT = 'NEW_TEMPLATE_CONTENT';
export const NEW_TEMPLATE_CATEGORY = 'NEW_TEMPLATE_CATEGORY';

export const EDIT_TEMPLATE_FOLDER = 'EDIT_TEMPLATE_FOLDER';
export const EDIT_TEMPLATE_NAME = 'EDIT_TEMPLATE_NAME';
export const EDIT_TEMPLATE_API_NAME = 'EDIT_TEMPLATE_API_NAME';
export const EDIT_TEMPLATE_DESCRIPTION = 'EDIT_TEMPLATE_DESCRIPTION';
export const EDIT_TEMPLATE_CONTENT = 'EDIT_TEMPLATE_CONTENT';
export const EDIT_TEMPLATE_CATEGORY = 'EDIT_TEMPLATE_CATEGORY';


// WEBPACK FOOTER //
// ./src/views/email/emailTemplatesCreation/flow/actionType.js